import { render, staticRenderFns } from "./Applicationstest.vue?vue&type=template&id=49aa2a7e&scoped=true&"
import script from "./Applicationstest.vue?vue&type=script&lang=js&"
export * from "./Applicationstest.vue?vue&type=script&lang=js&"
import style0 from "./Applicationstest.vue?vue&type=style&index=0&id=49aa2a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aa2a7e",
  null
  
)

export default component.exports